import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UserPrefsInfoFragment = { __typename?: 'UserPrefs', id: string, privateCommentsEnabled?: boolean | null, timeDisplayFormat: Types.TimeDisplayFormat, previewEnvironmentBanner?: boolean | null, transcriptionsLanguage?: string | null, hasTranscriptionConsent?: boolean | null, downloadSettings: { __typename?: 'UserPrefsDownloadSettings', locations?: Array<string> | null, shouldImport?: boolean | null }, exploreTemplatesBannerSettings: { __typename?: 'UserPrefsExploreTemplatesBannerSettings', shouldShowExploreTemplatesBanner: boolean } };

export const UserPrefsInfo = /*#__PURE__*/ gql`
    fragment UserPrefsInfo on UserPrefs {
  id
  privateCommentsEnabled
  timeDisplayFormat
  downloadSettings {
    locations
    shouldImport
  }
  exploreTemplatesBannerSettings {
    shouldShowExploreTemplatesBanner
  }
  previewEnvironmentBanner
  transcriptionsLanguage
  hasTranscriptionConsent
}
    ` as unknown as DocumentNode<UserPrefsInfoFragment, unknown>;

        

        
export const useUserPrefsInfoFragment = (
  input: string | Omit<UseFragmentOptions<UserPrefsInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'UserPrefs' } };
    return input;
  })();

  return useFragment<UserPrefsInfoFragment>({
    fragment: UserPrefsInfo,
    fragmentName: 'UserPrefsInfo',
    ...options,
  });
};
  
        